import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import InsuranceExemptionList from './InsuranceExemptionList';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (values: string[]) => void;
	patientIdentifier: string;
	initialExemptionedItems?: string[];
}

const InsuranceExemptionListModal: React.FC<Props> = ({
	isOpen,
	onClose,
	onSubmit,
	patientIdentifier,
	initialExemptionedItems,
}) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header
				title='nczi.electronicDPN.create.insuranceExemption.title'
				firstUpper
			/>
			<Modal.Content contentScroll>
				<InsuranceExemptionList
					onSubmit={onSubmit}
					patientIdentifier={patientIdentifier}
					initialExemptionedItems={initialExemptionedItems}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default InsuranceExemptionListModal;
